// 管理端路由配置。
// 所有管理端代码都收敛在 src/admin/ 下，本文件对外只导出 adminRoutes，
// 主路由（src/router.js）通过扩展运算符挂载即可，后续可整体拷贝剥离为独立应用。
import Login from './views/Login.vue'
import AdminLayout from './layouts/AdminLayout.vue'
import Dashboard from './views/Dashboard.vue'
import YcLogs from './views/yingchuan/Logs.vue'
import YcUserData from './views/yingchuan/UserData.vue'
import Yingkong from './views/Yingkong.vue'
import Policies from './views/Policies.vue'

export const adminRoutes = [
  {
    path: '/admin/login',
    name: 'adminLogin',
    component: Login,
    meta: { hideChrome: true, title: '管理端 · 登录' },
  },
  {
    path: '/admin',
    component: AdminLayout,
    meta: { hideChrome: true, requiresAuth: true, title: '管理端' },
    children: [
      { path: '', redirect: { name: 'adminDashboard' } },
      {
        path: 'dashboard',
        name: 'adminDashboard',
        component: Dashboard,
        meta: { title: '管理端 · 仪表盘' },
      },
      // 影传模块
      {
        path: 'yingchuan/logs',
        name: 'ycLogs',
        component: YcLogs,
        meta: { title: '影传 · 日志' },
      },
      {
        path: 'yingchuan/users',
        name: 'ycUsers',
        component: YcUserData,
        meta: { title: '影传 · 用户数据' },
      },
      // 影控模块（建设中）
      {
        path: 'yingkong',
        name: 'ykIndex',
        component: Yingkong,
        meta: { title: '影控' },
      },
      // 协议页面管理
      {
        path: 'policies',
        name: 'adminPolicies',
        component: Policies,
        meta: { title: '协议页面管理' },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/admin/index.js